import Vue from "vue";

export class LiveKitSpeakingController {
    private _speakingStatus: Record<string, boolean> = Vue.observable({});

    get speakingStatus() {
        return this._speakingStatus;
    }

    setStatus(identity: string, state: boolean) {
        Vue.set(this._speakingStatus, identity, state);
    }

    remove(identity: string) {
        Vue.delete(this._speakingStatus, identity);
    }

    isSpeaking(identity: string) {
        return this._speakingStatus[identity] ?? false;
    }

    clear() {
        this._speakingStatus = null as any;
    }
}
